module.exports = __webpack_public_path__ + "img/classroom-1.0b1ff039.png";